import schemaForm from './schema.json'
import TagsProvider from '../resources/TagsProvider'

const schema = schemaForm
const tagsService = new TagsProvider()

async function tagOptions () {
  let result
  try {
    const { data } = await tagsService.getAllTags()
    result = data.map((tag) => tag.doc.name)
  } catch (e) {
    console.error('tagOptions', e)
  }

  return result
}

export default {
  schema,
  tagOptions
}
